export const GENERATOR_TYPES = ['music', 'rap', 'cover', 'tts'] as const

export type GeneratorType = (typeof GENERATOR_TYPES)[number]

/** Maps dynamic route [type] param → original public URL path (for SEO data fetch) */
export const TYPE_TO_URL: Record<GeneratorType, string> = {
  music: '/ai-music-generator',
  rap: '/ai-rap-generator',
  cover: '/ai-cover-generator',
  tts: '/text-to-speech',
}

export function getFallbackTitle(
  type: GeneratorType,
  t: (template: TemplateStringsArray, ...args: unknown[]) => string,
): string {
  switch (type) {
    case 'music':
      return t`AI Music Generator`
    case 'rap':
      return t`AI Rap Generator`
    case 'cover':
      return t`AI Cover Generator`
    case 'tts':
      return t`Text to Speech`
  }
}
